import type { IconData } from '@stacksjs/iconify-core'

export const shoppingShippingBarcode: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M.76 17.53h30.48v-4.57H.76Zm1.53-3.05h27.43V16H2.29Zm25.9 4.57h1.53v9.14h-1.53Zm0-15.24h1.53v7.62h-1.53Zm-3.04 15.24h1.52v9.14h-1.52Zm0-15.24h1.52v7.62h-1.52Zm-4.58 0h3.05v7.62h-3.05Zm0 15.24h3.05v9.14h-3.05Zm-3.04 0h1.52v9.14h-1.52Zm0-15.24h1.52v7.62h-1.52Zm-7.62 0h3.05v7.62H9.91Zm0 15.24h3.05v9.14H9.91Zm-3.05 0h1.52v9.14H6.86Zm0-15.24h1.52v7.62H6.86Zm-4.57 0h3.05v7.62H2.29Zm0 15.24h3.05v9.14H2.29Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default shoppingShippingBarcode
